
import { Vue, Component } from 'vue-property-decorator'
import { TotalDataDTO, DataDTO, getOrderMonitoringTotal, getCustomerOrderFan, getCustomerOrderByLever, getCustomerOrderByCId, getOrderMonitoringByDay, getOrderMonitoringByWeek, getOrderMonitoringByMonth } from '@/api/dataReport'
import dayjs from 'dayjs'
import { moneyFormat, handlePercentage, handleAmount } from '@/utils/util'
import { exportFileWithData } from '@/utils/h5ToApp'
import DataSelect from '@/views/dataReport/template/dataSelect.vue'
import TypeProp from '@/views/dataReport/template/TypeProp.vue'
import { Chart } from '@antv/g2'
import LineListCard from '@/views/dataReport/template/lineListCard.vue'
import moment from 'moment'
import { Getter } from 'vuex-class'
import { colors } from './chartColors'

@Component({
    components: {DataSelect, TypeProp, LineListCard}
})
export default class OrderReport extends Vue {
    @Getter companyId!: string

    moneyFormat = moneyFormat
    handleAmount = handleAmount
    handlePercentage = handlePercentage
    colors = colors
    readonly format = 'YYYY-MM-DD'


    finished = false
    loading = false
    refreshing = false

    legendMore = false // chart图标是否查看更多

    queryParams = {
        type: 1,
        isPage: 'false',
        startTime: moment().month(moment().month() - 2).format(this.format),
        endTime: dayjs().format(this.format),
    }

    sortType = 1 // 排序方式
    customerType = 1 // 数据请求类型
    pageSize = 10
    pageIndex = 1

    showSortPop = false // 排序方式弹框显示与否
    showTypePop = false // 数据请求类型弹框显示与否

    sortTypeList = [
        {
            text: '订货金额排行',
            value: 1
        },
        {
            text: '退款金额排行',
            value: 2
        },
        {
            text: '退货金额排行',
            value: 3
        },
    ] // 排序方式列表

    customerTypeList = [
        {
            text: '按客户统计',
            value: 1
        },
        {
            text: '按客户级别统计',
            value: 2
        },
    ] // 数据请求方式列表

    totalDataType = [
        {
            key: 'orderSum',
            title: '订货单'
        },
        {
            key: 'returnOrderSum',
            title: '退货单'
        },
        {
            key: 'orderMoney',
            title: '订货金额',
            type: 'money'
        },
        {
            key: 'returnOrderMoney',
            title: '获批退款金额',
            type: 'money'
        },
        {
            key: 'returnMoneySum',
            title: '退货金额',
            type: 'money'
        },
        {
            key: 'differenceMoney',
            title: '合计总金额',
            type: 'money'
        }
    ] //总数量统计字段类型

    totalData: TotalDataDTO | any = {}

    listType = [
        // {
        //   text: '订货单',
        //   key: 'orderSum',
        // },
        // {
        //   text: '订货金额',
        //   key: 'orderMoney',
        //   type: 'money'
        // },
        // {
        //   text: '退货单',
        //   key: 'returnOrderSum',
        // },
        {
            text: '退货金额',
            key: 'returnMoneySum',
            type: 'money'
        },
        {
            text: '获批退款金额',
            key: 'returnMoney',
            type: 'money'
        },
    ]

    chartData: DataDTO[] = []
    chart: Chart | null = null
    list: DataDTO[] = []

    created () {
        this.load()
    }

    mounted () {
        this.initChart()
    }

    load () {
        this.pageIndex = 1
        this.list = []
        this.getOrderMonitoringTotal()
        this.getCustomerOrderFan()
        this.getList()
    }

    get sortTypeText () {
        let text = '订货金额'
        switch (this.sortType + '') {
            case '1':
                text = '订货金额'
                break
            case '2':
                text = '退款金额'
                break
            case '3':
                text = '退货金额'
                break
            default:
                text = '订货金额'
                break
        }
        return text
    }

    /**
     * 下拉刷新
     * */
    onRefresh () {
        this.refreshing = true
        this.load()
    }

    /**
     * 获取头部总数量统计数据
     */
    getOrderMonitoringTotal () {
        getOrderMonitoringTotal({
            startTime: this.queryParams.startTime,
            endTime: this.queryParams.endTime
        }).then(res => {
            this.totalData = res.data[0]
        })
    }

    /**
     * 获取饼图数据
     */
    getCustomerOrderFan () {
        if (this.sortType === 1 && this.customerType === 1) this.queryParams.type = 1
        if (this.sortType === 2 && this.customerType === 1) this.queryParams.type = 2
        if (this.sortType === 1 && this.customerType === 2) this.queryParams.type = 3
        if (this.sortType === 2 && this.customerType === 2) this.queryParams.type = 4
        if (this.sortType === 3 && this.customerType === 1) this.queryParams.type = 5
        if (this.sortType === 3 && this.customerType === 2) this.queryParams.type = 6
        getCustomerOrderFan({...this.queryParams}).then((res: any) => {
            this.chartData = res.data instanceof Array ? res.data : []
            this.chartData.map((item,index) => {
                item.orderMoney = typeof item.orderMoney === 'string' ? parseFloat(item.orderMoney) : item.orderMoney
                item.random = item.name + index
            })
            this.$nextTick(() => {
                this.chart!.data(this.chartData)
                this.chart!.render()
            })
        })
    }

    // 饼图配置
    initChart () {
        const data: any = [
            {name: '', orderMoney: 0,random:''}
        ]
        const chart = new Chart({
            container: 'order-chart-container',
            autoFit: true,
            height: 280
        })

        chart.legend(false)

        chart.coordinate('theta', {
            radius: 0.6,
            innerRadius: 0.55
        })

        chart.data(data)

        chart.tooltip({
            showTitle: false,
            showMarkers: false
        })

        chart
            .interval()
            .position('orderMoney')
            .color('random', this.colors)
            .label('percentage', (val) => {
                let isLabel = val > 0.2
                if (isLabel) {
                    return {
                        content: (data) => {
                            return `${data.name.length > 5 ? data.name.slice(0, 5) + ' ...' : data.name}:\n ${handlePercentage(data.percentage)}`
                        },
                        style: {
                            fill: '#313131',
                        },
                        layout: {type: 'pie-spider'},
                    }
                }
            })
            .tooltip('name*orderMoney', (name, orderMoney) => {
                return {
                    name: name,
                    value: moneyFormat(orderMoney),
                }
            })
            .adjust('stack')

        chart.interaction('element-active')

        chart.render()
        this.chart = chart
    }

    getList () {
        this.loading = true
        if (this.sortType === 1 && this.customerType === 1) this.queryParams.type = 1
        if (this.sortType === 2 && this.customerType === 1) this.queryParams.type = 2
        if (this.sortType === 1 && this.customerType === 2) this.queryParams.type = 3
        if (this.sortType === 2 && this.customerType === 2) this.queryParams.type = 4
        // 表格
        let param = {
            startTime: this.queryParams.startTime,
            endTime: this.queryParams.endTime,
            isPage: true,
            pageSize: this.pageSize,
            pageIndex: this.pageIndex,
            order: this.sortType
        }
        const requests = [getCustomerOrderByCId, getCustomerOrderByLever]
        requests[this.customerType - 1]({
            ...param
        }).then(res => {
            this.list = this.list.concat(res.data.records)
            if (this.list.length >= res.data.totalRecords) {
                this.finished = true
            }
            this.pageIndex++
        }).finally(() => {
            this.loading = false
            this.refreshing = false
        })
    }

    /**
     * 头部总时间段改变
     * @param value
     */
    handleDataChange (value: Array<string>) {
        this.queryParams.startTime = value[0]
        this.queryParams.endTime = value[1]
        this.load()
    }

    /**
     * 数据请求类型改变
     * @param data
     */
    handleCustomerTypeChange (data: { text: string, value: number }) {
        this.showTypePop = false
        this.customerType = data.value
        this.load()
    }

    handleSortTypeChange (data: { text: string, value: number }) {
        this.showSortPop = false
        this.sortType = data.value
        this.load()
    }

    /**
     * 导出
     */
    handleExport () {
        let param = {
            startTime: this.queryParams.startTime,
            endTime: this.queryParams.endTime,
            order: this.sortType,
            type: this.customerType,
            companyId: this.companyId
        }
        exportFileWithData({
            method: 'post',
            portUrl: '/cykjreport/CustomerOrderStatistics/exportPullCustomerOrder',
            params: JSON.stringify(param)
        })
    }
}
